export const BaseUrl = "https://task-managerbackend.herokuapp.com"
export const TaskUrl = "https://task-managerbackend.herokuapp.com/tasks"
export const LoginUrl = "https://task-managerbackend.herokuapp.com/user/login"
export const RegisterUrl = "https://task-managerbackend.herokuapp.com/user/register"
